import React from "react";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import GrassIcon from '@mui/icons-material/Grass';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SearchIcon from '@mui/icons-material/Search';
import InboxIcon from '@mui/icons-material/Inbox';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import BusinessIcon from '@mui/icons-material/Business';

const CoccionSection = ({
  coccionRecords = [],
  pagination,
  coccionSearch = "",
  onSearchChange,
  onPageChange,
  isFormOpen,
  setIsFormOpen,
  formData,
  setFormData,
  magueySpecies,
  handleSaveCoccion,
  handleCancelCoccion,
  handleRejectCoccion,
  instalaciones = []
}) => {
  const [selectedRecord, setSelectedRecord] = React.useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditRecord = (rec) => {
    if (rec.status !== "borrador" && rec.status !== "rechazado") {
      Swal.fire({
        title: "Acción restringida",
        text: "Solo se pueden editar registros que se encuentren en estado BORRADOR o RECHAZADO.",
        icon: "warning",
        confirmButtonColor: "#4A5D23"
      });
      return;
    }
    setFormData({
      id: rec.id,
      rawId: rec.rawId || (typeof rec.id === 'number' ? rec.id : null),
      idUnidadProduccion: rec.idUnidadProduccion || rec.id_unidad_produccion || "",
      noProduccion: rec.noProduccion || "",
      numPinas: rec.pinas || rec.numPinas || "",
      kgMaguey: rec.kgMaguey ? String(rec.kgMaguey).replace(/[^\d.]/g, '') : "",
      fechaIngreso: rec.fechaIngreso || "",
      guiaPredio: rec.guiaPredio || "",
      tipoMaguey: rec.tipoMaguey || "",
      pctArt: rec.pctArt ? String(rec.pctArt).replace(/[^\d.]/g, '') : "",
      noInforme: rec.noInforme || "",
      fechaInicioCoccion: rec.fechaInicioCoccion || rec.fechaInicio || "",
      fechaFinCoccion: rec.fechaFinCoccion || rec.fechaFin || "",
      kgMagueyCocido: rec.kgMagueyCocido ? String(rec.kgMagueyCocido).replace(/[^\d.]/g, '') : "",
      observaciones: rec.observaciones || "",
      observacionesCorreccion: rec.observacionesCorreccion || rec.observaciones_correccion || "",
      status: rec.status || "borrador"
    });
    setIsFormOpen(true);
  };

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header" style={{ flexWrap: "wrap", gap: "16px" }}>
          <div>
            <h2>Historial de Bitácoras de Cocción (Sección II)</h2>
            <p className="subtitle-history">Registros oficiales de horneado e ingreso de materia prima</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            {/* Campo de búsqueda */}
            <div style={{ position: "relative", minWidth: "260px" }}>
              <SearchIcon style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", fontSize: 20 }} />
              <input
                type="text"
                placeholder="Buscar por no. prod, predio, maguey..."
                value={coccionSearch}
                onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
                style={{
                  width: "100%",
                  paddingLeft: "38px",
                  paddingRight: "12px",
                  paddingTop: "9px",
                  paddingBottom: "9px",
                  borderRadius: "12px",
                  border: "1px solid #D1D5DB",
                  fontSize: "13px",
                  outline: "none",
                  backgroundColor: "white"
                }}
              />
            </div>
            <button
              onClick={() => {
                setFormData({
                  id: null,
                  rawId: null,
                  idUnidadProduccion: "",
                  noProduccion: "",
                  numPinas: "",
                  kgMaguey: "",
                  fechaIngreso: "",
                  guiaPredio: "",
                  tipoMaguey: magueySpecies[0]?.name ? `${magueySpecies[0].name} (${magueySpecies[0].scientific})` : "",
                  pctArt: "",
                  noInforme: "",
                  fechaInicioCoccion: "",
                  fechaFinCoccion: "",
                  kgMagueyCocido: "",
                  observaciones: ""
                });
                setIsFormOpen(true);
              }}
              className="btn-add-new"
            >
              <AddIcon />
              <span>Nueva Bitácora de Cocción</span>
            </button>
          </div>
        </div>

        {/* TABLA HISTÓRICA O MENSAJE SIN REGISTROS */}
        {coccionRecords.length === 0 ? (
          <div className="empty-state-container" style={{ background: "white", borderRadius: "16px", border: "1px solid var(--glass-border)", padding: "48px 24px", margin: "16px 0", textAlign: "center" }}>
            <InboxIcon style={{ fontSize: 48, color: "var(--copper)", opacity: 0.6, marginBottom: "12px" }} />
            <h3 style={{ margin: "0 0 6px 0", color: "var(--text-primary)", fontSize: "16px", fontWeight: 700 }}>
              {coccionSearch ? "No se encontraron resultados" : "No hay bitácoras de cocción registradas"}
            </h3>
            <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "13px" }}>
              {coccionSearch ? `No se hallaron registros coincidentes con "${coccionSearch}".` : "Actualmente no existen registros guardados. Haga clic en 'Nueva Bitácora de Cocción' para agregar uno."}
            </p>
          </div>
        ) : (
          <div className="table-responsive-container">
            <table className="custom-table-bitacora">
              <thead>
                <tr>
                  <th>No. Producción</th>
                  <th>Unidad de Producción</th>
                  <th>Piñas</th>
                  <th>kg Maguey</th>
                  <th>Fecha Ingreso</th>
                  <th>Guía / Predio</th>
                  <th>Inspector</th>
                  <th>Estatus</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {coccionRecords.map((rec) => {
                  const kgMagueyStr = rec.kgMaguey != null ? (String(rec.kgMaguey).includes('kg') ? rec.kgMaguey : `${rec.kgMaguey} kg`) : '-';

                  return (
                    <tr key={rec.id}>
                      <td className="font-bold-primary">{rec.noProduccion}</td>
                      <td>
                        {(() => {
                          const targetId = rec.idUnidadProduccion || rec.id_unidad_produccion;
                          const inst = instalaciones.find(i => String(i.idanexocliente) === String(targetId));
                          const alias = rec.alias_instalacion || inst?.informaciongeneralinstalacioncliente?.alias || inst?.alias || (targetId ? `Unidad #${targetId}` : '-');
                          return <span style={{ fontWeight: 600, color: "var(--text-primary)", fontSize: "12.5px" }}>{alias}</span>;
                        })()}
                      </td>
                      <td style={{ fontWeight: 600 }}>{rec.pinas || rec.numPinas || '-'}</td>
                      <td>{kgMagueyStr}</td>
                      <td style={{ color: "var(--text-secondary)", fontSize: "12.5px" }}>{rec.fechaIngreso || '-'}</td>
                      <td>
                        <span style={{ fontWeight: 600, color: "var(--text-primary)" }}>{rec.guiaPredio || '-'}</span>
                      </td>
                      <td>
                        <span className="inspector-tag">{rec.inspector || 'Pendiente'}</span>
                      </td>
                      <td>
                        <span className={`badge-status ${rec.status || 'borrador'}`}>
                          {rec.status === "aprobado"
                            ? "Aprobado"
                            : rec.status === "enviado"
                              ? "Enviado"
                              : rec.status === "revision"
                                ? "En revisión"
                                : rec.status === "rechazado"
                                  ? "Rechazado (Para corrección)"
                                  : (rec.status === "cancelada" || rec.status === "cancelado")
                                    ? "Cancelada"
                                    : "Borrador"}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                          <button
                            onClick={() => setSelectedRecord(rec)}
                            title="Ver detalles completos"
                            className="btn-action-icon view"
                          >
                            <VisibilityIcon style={{ fontSize: 16 }} />
                          </button>
                          {(rec.status === "borrador" || rec.status === "rechazado") && (
                            <button
                              onClick={() => handleEditRecord(rec)}
                              title={rec.status === "rechazado" ? "Editar y corregir bitácora" : "Editar Borrador"}
                              className="btn-action-icon edit"
                            >
                              <EditIcon style={{ fontSize: 16 }} />
                            </button>
                          )}
                          {rec.status !== "cancelada" && rec.status !== "cancelado" && rec.status !== "aprobado" && rec.status !== "aceptada" && rec.status !== "aceptado" && handleCancelCoccion && (
                            <button
                              onClick={() => handleCancelCoccion(rec)}
                              title="Cancelar Bitácora"
                              className="btn-action-icon cancel"
                            >
                              <CancelIcon style={{ fontSize: 16 }} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* CONTROLES DE PAGINACIÓN */}
        {pagination && pagination.totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "16px", padding: "12px 16px", background: "white", borderRadius: "14px", border: "1px solid var(--glass-border)", flexWrap: "wrap", gap: "12px" }}>
            <span style={{ fontSize: "13px", color: "var(--text-secondary)" }}>
              Página <strong>{pagination.currentPage}</strong> de <strong>{pagination.totalPages}</strong> ({pagination.totalRecords} registros)
            </span>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                disabled={pagination.currentPage <= 1}
                onClick={() => onPageChange && onPageChange(pagination.currentPage - 1)}
                className="btn-secondary-custom"
                style={{ padding: "6px 12px", fontSize: "12px", display: "flex", alignItems: "center", gap: "4px", cursor: pagination.currentPage <= 1 ? "not-allowed" : "pointer", opacity: pagination.currentPage <= 1 ? 0.5 : 1 }}
              >
                <NavigateBeforeIcon style={{ fontSize: 18 }} /> Anterior
              </button>
              <button
                disabled={pagination.currentPage >= pagination.totalPages}
                onClick={() => onPageChange && onPageChange(pagination.currentPage + 1)}
                className="btn-secondary-custom"
                style={{ padding: "6px 12px", fontSize: "12px", display: "flex", alignItems: "center", gap: "4px", cursor: pagination.currentPage >= pagination.totalPages ? "not-allowed" : "pointer", opacity: pagination.currentPage >= pagination.totalPages ? 0.5 : 1 }}
              >
                Siguiente <NavigateNextIcon style={{ fontSize: 18 }} />
              </button>
            </div>
          </div>
        )}

        {/* MODAL DE DETALLE COMPLETO CON SCROLL VERTICAL VIA PORTAL AL BODY */}
        {selectedRecord && createPortal(
          <div
            className="detail-modal-overlay"
            onClick={() => setSelectedRecord(null)}
          >
            <div
              className="detail-modal-card animate-fadeIn"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="detail-modal-header">
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "14px",
                      background: "rgba(74, 93, 35, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "var(--agave-green)"
                    }}
                  >
                    <LocalFireDepartmentIcon style={{ fontSize: 26 }} />
                  </div>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <h3 style={{ margin: 0, color: "var(--agave-green)", fontSize: "18px", fontWeight: 800 }}>
                        {selectedRecord.noProduccion}
                      </h3>
                      <span className={`badge-status ${selectedRecord.status || 'borrador'}`}>
                        {selectedRecord.status === "aprobado" ? "Aprobado" : selectedRecord.status === "revision" ? "En revisión" : (selectedRecord.status === "cancelada" || selectedRecord.status === "cancelado") ? "Cancelada" : "Borrador"}
                      </span>
                    </div>
                    <span style={{ color: "var(--text-muted)", fontSize: "12px", display: "block", marginTop: "2px" }}>
                      Detalle Completo de Bitácora de Cocción
                    </span>
                  </div>
                </div>

                <button
                  onClick={() => setSelectedRecord(null)}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "1px solid #E5E7EB",
                    background: "#ffffff",
                    color: "var(--text-secondary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s"
                  }}
                  title="Cerrar modal"
                >
                  <CloseIcon style={{ fontSize: 20 }} />
                </button>
              </div>

              {/* Cuerpo con Scroll Vertical Garantizado */}
              <div className="detail-modal-body">

                {/* Tarjeta 0: Instalación / Unidad de Producción */}
                {(() => {
                  const selectedInst = instalaciones.find(i => String(i.idanexocliente) === String(selectedRecord.idUnidadProduccion));
                  const alias = selectedRecord.alias_instalacion || selectedInst?.informaciongeneralinstalacioncliente?.alias || selectedInst?.alias || (selectedRecord.idUnidadProduccion ? `Unidad de Producción #${selectedRecord.idUnidadProduccion}` : "No especificada");

                  let dir = selectedRecord.domicilio_instalacion || selectedInst?.informaciongeneralinstalacioncliente?.direccion;
                  if (!dir && selectedInst?.informaciongeneralinstalacioncliente) {
                    const info = selectedInst.informaciongeneralinstalacioncliente;
                    dir = [info.calle, info.numeroexterior || info.numext, info.colonia, info.municipio, info.estado].filter(Boolean).join(", ");
                  }
                  dir = dir || selectedInst?.direccion || "Dirección no especificada";

                  return (
                    <div style={{ background: "#FAF9F6", borderRadius: "16px", padding: "18px", border: "1px solid #EAE6DF" }}>
                      <h4 style={{ margin: "0 0 14px 0", fontSize: "13px", fontWeight: 800, textTransform: "uppercase", color: "var(--copper)", letterSpacing: "0.5px", display: "flex", alignItems: "center", gap: "6px" }}>
                        <BusinessIcon style={{ fontSize: 16 }} />
                        Instalación / Unidad de Producción
                      </h4>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "14px" }}>
                        <div>
                          <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Alias / Nombre</span>
                          <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>{alias}</strong>
                        </div>
                        <div style={{ gridColumn: "1 / -1" }}>
                          <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Dirección de la Instalación</span>
                          <strong style={{ fontSize: "13px", color: "var(--text-primary)", fontWeight: 500 }}>{dir}</strong>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Tarjeta 1: Materia Prima e Ingreso */}
                <div style={{ background: "#FAF9F6", borderRadius: "16px", padding: "18px", border: "1px solid #EAE6DF" }}>
                  <h4 style={{ margin: "0 0 14px 0", fontSize: "13px", fontWeight: 800, textTransform: "uppercase", color: "var(--agave-green)", letterSpacing: "0.5px", display: "flex", alignItems: "center", gap: "6px" }}>
                    <GrassIcon style={{ fontSize: 16 }} />
                    Materia Prima e Ingreso
                  </h4>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "14px" }}>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Nº de Piñas</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>{selectedRecord.pinas || selectedRecord.numPinas || '-'}</strong>
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>kg de Maguey</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>
                        {selectedRecord.kgMaguey != null ? (String(selectedRecord.kgMaguey).includes('kg') ? selectedRecord.kgMaguey : `${selectedRecord.kgMaguey} kg`) : '-'}
                      </strong>
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Fecha Ingreso</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>{selectedRecord.fechaIngreso || '-'}</strong>
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Guía / Predio</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>{selectedRecord.guiaPredio || '-'}</strong>
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Tipo de Maguey</span>
                      <span className="chip-maguey" style={{ marginTop: "4px" }}>
                        {selectedRecord.tipoMaguey || '-'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Tarjeta 2: Proceso de Cocción & Análisis */}
                <div style={{ background: "#FAF9F6", borderRadius: "16px", padding: "18px", border: "1px solid #EAE6DF" }}>
                  <h4 style={{ margin: "0 0 14px 0", fontSize: "13px", fontWeight: 800, textTransform: "uppercase", color: "var(--copper)", letterSpacing: "0.5px", display: "flex", alignItems: "center", gap: "6px" }}>
                    <LocalFireDepartmentIcon style={{ fontSize: 16 }} />
                    Proceso de Cocción & Análisis
                  </h4>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "14px" }}>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>% ART (Informe)</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>
                        {selectedRecord.pctArt != null && selectedRecord.pctArt !== "" ? (String(selectedRecord.pctArt).includes('%') ? selectedRecord.pctArt : `${selectedRecord.pctArt}%`) : 'N/A'}
                      </strong>
                      {selectedRecord.noInforme && (
                        <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px" }}>Informe: {selectedRecord.noInforme}</span>
                      )}
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Inicio Cocción</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>{selectedRecord.fechaInicioCoccion || selectedRecord.fechaInicio || '-'}</strong>
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>Fin Cocción</span>
                      <strong style={{ fontSize: "14px", color: "var(--text-primary)" }}>{selectedRecord.fechaFinCoccion || selectedRecord.fechaFin || '-'}</strong>
                    </div>
                    <div>
                      <span style={{ display: "block", color: "var(--text-muted)", fontSize: "11px", fontWeight: 600 }}>kg Maguey Cocido</span>
                      <strong style={{ fontSize: "15px", color: "var(--copper)", fontWeight: 800 }}>
                        {selectedRecord.kgMagueyCocido != null ? (String(selectedRecord.kgMagueyCocido).includes('kg') ? selectedRecord.kgMagueyCocido : `${selectedRecord.kgMagueyCocido} kg`) : '-'}
                      </strong>
                    </div>
                  </div>
                </div>

                {/* Tarjeta 3: Inspección y Observaciones */}
                <div style={{ background: "#FAF9F6", borderRadius: "16px", padding: "18px", border: "1px solid #EAE6DF" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <span style={{ color: "var(--text-muted)", fontSize: "12px", fontWeight: 700 }}>Inspector Asignado:</span>
                    <span className="inspector-tag">{selectedRecord.inspector || 'Pendiente de V.Bo.'}</span>
                  </div>
                  <div style={{ borderTop: "1px border-dashed #E5E7EB", paddingTop: "10px" }}>
                    <span style={{ color: "var(--text-muted)", fontSize: "12px", fontWeight: 700 }}>Observaciones Generales:</span>
                    <p style={{ margin: "4px 0 0 0", color: "var(--text-primary)", fontSize: "13px", fontStyle: selectedRecord.observaciones ? "normal" : "italic" }}>
                      {selectedRecord.observaciones || "Sin observaciones registradas."}
                    </p>
                  </div>
                  {(selectedRecord.observacionesCorreccion || selectedRecord.observaciones_correccion) && (
                    <div style={{ borderTop: "1px border-dashed #FCA5A5", paddingTop: "10px", marginTop: "10px" }}>
                      <span style={{ color: "#991B1B", fontSize: "12px", fontWeight: 700, display: "flex", alignItems: "center", gap: "4px" }}>
                        <ReportProblemIcon style={{ fontSize: 16, color: "#DC2626" }} />
                        Observaciones de Corrección (Inspector Área):
                      </span>
                      <p style={{ margin: "4px 0 0 0", color: "#7F1D1D", fontSize: "13px", fontWeight: 600 }}>
                        {selectedRecord.observacionesCorreccion || selectedRecord.observaciones_correccion}
                      </p>
                    </div>
                  )}
                </div>

              </div>

              {/* Footer */}
              <div className="detail-modal-footer">
                {(selectedRecord.status === "borrador" || selectedRecord.status === "rechazado") && (
                  <button
                    onClick={() => {
                      const rec = selectedRecord;
                      setSelectedRecord(null);
                      handleEditRecord(rec);
                    }}
                    className="btn-add-new"
                    style={{ padding: "8px 16px", fontSize: "13px" }}
                  >
                    <EditIcon style={{ fontSize: 16 }} />
                    <span>{selectedRecord.status === "rechazado" ? "Editar y Corregir" : "Editar Borrador"}</span>
                  </button>
                )}
                {selectedRecord.status !== "cancelada" && selectedRecord.status !== "cancelado" && selectedRecord.status !== "aprobado" && selectedRecord.status !== "aceptada" && selectedRecord.status !== "aceptado" && handleCancelCoccion && (
                  <button
                    onClick={() => {
                      const rec = selectedRecord;
                      setSelectedRecord(null);
                      handleCancelCoccion(rec);
                    }}
                    className="btn-action-icon cancel"
                    style={{ width: "auto", padding: "8px 16px", height: "auto", borderRadius: "10px", fontWeight: 700, fontSize: "13px", display: "flex", gap: "6px", alignItems: "center" }}
                  >
                    <CancelIcon style={{ fontSize: 16 }} />
                    <span>Cancelar</span>
                  </button>
                )}
                <button
                  onClick={() => setSelectedRecord(null)}
                  className="btn-secondary-custom"
                  style={{ padding: "8px 20px", fontSize: "13px" }}
                >
                  Cerrar
                </button>
              </div>

            </div>
          </div>,
          document.body
        )}
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>{formData.rawId || formData.id ? "Editar / Corregir Bitácora de Cocción" : "Nueva Bitácora de Cocción"}</h2>
      </div>

      {formData.status === "rechazado" && (
        <div style={{ background: "#FEF2F2", border: "1px solid #FCA5A5", borderRadius: "14px", padding: "16px 20px", marginBottom: "20px", display: "flex", gap: "12px", alignItems: "flex-start" }}>
          <ReportProblemIcon style={{ color: "#DC2626", marginTop: "2px" }} />
          <div>
            <h4 style={{ margin: "0 0 4px 0", color: "#991B1B", fontSize: "14px", fontWeight: 700 }}>
              Bitácora Rechazada por el Área de Inspección
            </h4>
            <p style={{ margin: 0, color: "#7F1D1D", fontSize: "13px" }}>
              <strong>Observaciones del inspector:</strong> {formData.observacionesCorreccion || formData.observaciones_correccion || "Por favor revise los datos del registro, realice las correcciones pertinentes y vuelva a enviar la solicitud para revisión."}
            </p>
          </div>
        </div>
      )}

      <div className="cards-container-grid">
        {/* Materia Prima Card */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <GrassIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Materia Prima</h2>
              <p>Datos de cosecha y características del agave crudo</p>
            </div>
          </header>

          <div className="custom-input-group" style={{ marginBottom: "16px" }}>
            <select
              id="idUnidadProduccion"
              name="idUnidadProduccion"
              value={formData.idUnidadProduccion || ""}
              onChange={handleChange}
              className="custom-select-field"
              style={{ padding: "18px 16px 8px 16px" }}
            >
              <option value="">-- Seleccionar Instalación / Unidad de Producción --</option>
              {instalaciones.map((inst) => {
                const idAnexo = inst.idanexocliente;
                const infoGen = inst.informaciongeneralinstalacioncliente || inst;
                const alias = infoGen?.alias || `Instalación #${idAnexo}`;

                let dir = infoGen?.direccion;
                if (!dir && infoGen) {
                  dir = [infoGen.calle, infoGen.numeroexterior || infoGen.numext, infoGen.colonia, infoGen.municipio, infoGen.estado].filter(Boolean).join(", ");
                }
                dir = dir || inst.direccion || "";

                return (
                  <option key={idAnexo} value={idAnexo}>
                    {alias} {dir ? `— ${dir}` : ''}
                  </option>
                );
              })}
            </select>
            <label className="custom-input-label" htmlFor="idUnidadProduccion">Instalación (Unidad de Producción - Anexo 1)</label>
          </div>

          <div className="custom-input-group">
            <input
              type="text"
              id="noProduccion"
              name="noProduccion"
              value={formData.noProduccion || ""}
              onChange={handleChange}
              className="custom-input-field"
            />
            <label className="custom-input-label" htmlFor="noProduccion">No. de Producción</label>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                id="numPinas"
                name="numPinas"
                value={formData.numPinas || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="numPinas">Número de Piñas</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                id="kgMaguey"
                name="kgMaguey"
                value={formData.kgMaguey || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="kgMaguey">kg de Maguey</label>
              <span className="input-suffix">kg</span>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="date"
                id="fechaIngreso"
                name="fechaIngreso"
                value={formData.fechaIngreso || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="fechaIngreso">Fecha Ingreso Maguey</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                id="guiaPredio"
                name="guiaPredio"
                value={formData.guiaPredio || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="guiaPredio">Nº de Guía / Predio</label>
            </div>
          </div>

          <div className="custom-input-group">
            <select
              name="tipoMaguey"
              value={formData.tipoMaguey || ""}
              onChange={handleChange}
              className="custom-select-field"
              style={{ padding: "18px 16px 8px 16px" }}
            >
              {magueySpecies.map((sp, idx) => (
                <option key={idx} value={`${sp.name} (${sp.scientific})`}>
                  {sp.name} ({sp.scientific})
                </option>
              ))}
            </select>
            <label className="custom-input-label">Tipo de Maguey (Catálogo)</label>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                step="0.1"
                id="pctArt"
                name="pctArt"
                value={formData.pctArt || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="pctArt">% de ART en Maguey Crudo</label>
              <span className="input-suffix">% ART</span>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                id="noInforme"
                name="noInforme"
                value={formData.noInforme || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="noInforme">Nº de Informe</label>
            </div>
          </div>
        </section>

        {/* Proceso Coccion Card */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <LocalFireDepartmentIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Proceso de Cocción</h2>
              <p>Horneado del agave y control de peso cocido</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="date"
                id="fechaInicioCoccion"
                name="fechaInicioCoccion"
                value={formData.fechaInicioCoccion || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="fechaInicioCoccion">Fecha Inicial de Cocción</label>
            </div>

            <div className="custom-input-group">
              <input
                type="date"
                id="fechaFinCoccion"
                name="fechaFinCoccion"
                value={formData.fechaFinCoccion || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="fechaFinCoccion">Fecha Final de Cocción</label>
            </div>
          </div>

          <div className="custom-input-group">
            <input
              type="number"
              id="kgMagueyCocido"
              name="kgMagueyCocido"
              value={formData.kgMagueyCocido || ""}
              onChange={handleChange}
              className="custom-input-field"
            />
            <label className="custom-input-label" htmlFor="kgMagueyCocido">kg de Maguey Cocido</label>
            <span className="input-suffix">kg</span>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea
              id="observaciones"
              name="observaciones"
              value={formData.observaciones || ""}
              onChange={handleChange}
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
            />
            <label className="custom-input-label" htmlFor="observaciones">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => handleSaveCoccion("borrador")}>Guardar Borrador</button>
        <button type="button" className="btn-primary-copper" onClick={() => handleSaveCoccion("revision")}>
          <span>Firmar y Registrar Cocción</span>
          <ArrowForwardIcon style={{ fontSize: 16 }} />
        </button>
      </div>
    </div>
  );
};

export default CoccionSection;
